
  import { COOKIE_SELECTED_PRODUCT } from '@/constants/cookies';
  import { productToCookie } from '@/scripts/utils';

  export default {
    props: {
      articleEmbed: { type: Boolean, default: false },
      card: { type: Object, required: true }
    },
    computed: {
      path () {
        return this.localePath(`/compare-credit-cards/${this.card.institution.slug}/${this.card.code}/${this.card.slug}/`);
      }
    },
    methods: {
      saveToCookies () {
        this.$cookies.set(COOKIE_SELECTED_PRODUCT, productToCookie(this.card));
      }
    }
  };
